import React from 'react';
import { useNavigate } from 'react-router-dom';
import PeopleIcon from '@mui/icons-material/People';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import EmailIcon from '@mui/icons-material/Email';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import BusinessIcon from '@mui/icons-material/Business';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppShell } from '../../ui';

export const ADMIN_NAV = [
  { label: 'Users', value: 'users', icon: <PeopleIcon fontSize="small" /> },
  { label: 'Support tickets', value: 'supportTickets', icon: <SupportAgentIcon fontSize="small" /> },
  { label: 'Coupons', value: 'coupons', icon: <LocalOfferIcon fontSize="small" /> },
  { label: 'Mail users', value: 'mailUsers', icon: <EmailIcon fontSize="small" /> },
  { label: 'Installers', value: 'updateInstaller', icon: <SystemUpdateAltIcon fontSize="small" /> },
  { label: 'Licenses', value: 'licenses', icon: <VpnKeyIcon fontSize="small" /> },
  { label: 'Org licenses', value: 'orgLicensing', icon: <BusinessIcon fontSize="small" /> },
];

/**
 * Frame for the Vavetek super admin pages. `selected`/`onSelect` drive the dashboard tabs; pages outside the
 * dashboard (e.g. a single user) leave onSelect out and the menu goes back to the dashboard on that tab.
 */
const AdminShell = ({ selected, onSelect, children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('jwttoken');
    sessionStorage.removeItem('jwttoken');
    navigate('/superadmin');
  };

  return (
    <AppShell
      area="Admin"
      homeTo="/admin/dashboard"
      nav={ADMIN_NAV}
      selected={selected}
      onSelect={onSelect || ((view) => navigate('/admin/dashboard', { state: { view } }))}
      account={{
        name: localStorage.getItem('user') || 'Vavetek admin',
        email: localStorage.getItem('email') || undefined,
        items: [{ label: 'Log out', onClick: handleLogout, icon: <LogoutIcon fontSize="small" /> }],
      }}
    >
      {children}
    </AppShell>
  );
};

export default AdminShell;
